export default __webpack_public_path__ + "static/media/icon-physical.85da44aa.png";